<template>
  <c-row>
    <c-col md="12" lg="7">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Bootstrap Carousel</strong>
          <div class="card-header-actions">
            <a
              href="https://coreui.io/vue/docs/components/carousel"
              class="card-header-action"
              rel="noreferrer noopener"
              target="_blank"
            >
              <small class="text-muted">docs</small>
            </a>
          </div>
        </c-card-header>
        <c-card-body>
          <c-carousel arrows indicators animate height="400px">
            <c-carousel-item
              caption-header="First Slide"
              image="https://picsum.photos/1024/480/?image=52"
              caption-text="Nulla vitae elit libero, a pharetra augue mollis interdum."
            />
            <c-carousel-item
              caption-header="Blank page"
              :image="{ placeholderColor: 'grey' }"
              caption-text="Nulla vitae elit libero, a pharetra augue mollis interdum."
            />
            <c-carousel-item image="https://picsum.photos/1024/480/?image=54" />
          </c-carousel>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>

<script>
export default {
  name: 'Carousels',
};
</script>
